import { CurrencyEnum } from '__generated__/types';
import { FlagSingapore } from '@xometry/icons';
import { RegionData, RegionLocales, Regions } from 'config/regions/types';
import { ENV_APP_HOST_SG, ENV_CUSTOMERS_APP_HOST_SG, ENV_PARTNERS_APP_HOST_SG } from 'constants/env';

export const SGRegionConfig: RegionData<Regions.SG> = {
  region: Regions.SG,
  orgName: 'Xometry SG',
  name: 'SG',
  shortName: 'SG',
  locale: RegionLocales.EN,
  currency: 'USD' as CurrencyEnum,
  icon: FlagSingapore,
  host: ENV_APP_HOST_SG,
  customersHost: ENV_CUSTOMERS_APP_HOST_SG,
  partnersHost: ENV_PARTNERS_APP_HOST_SG,
  headerColor: '#4A4AA8',
};
